import { Button, message, Modal } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import ReactToPrint from "react-to-print";
import documentloader from "../../../Assets/Images/awbcustomsloader.gif";
// import Companyseal from "../../../Assets/Images/seal.JPG";
import Companyseal from "../../../Assets/Images/sahari-seal.png";
import { API, Headers } from "../../../Config";

function PrintPackingInvoiceModal(props) {
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRate, setSelectedRate] = useState({});

  useEffect(() => {
    loadBoxesViaAwb();
  }, []);

  const loadBoxesViaAwb = () => {
    const AWBID = props?.selected && props?.selected[0]?.id;
    let URL = API.BASR_URL + API.BOXES_VIA_AWB + AWBID;
    axios
      .get(URL, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response?.status === 200) {
          let data = response?.data;
          setData(data);
          setIsLoading(false);
        } else {
          message.error("Ooops. Something went wrong...!");
          setIsLoading(false);
        }
      });
  };

  // Custom sorting function for box_number
  const sortBoxNumber = (a, b) => {
    const boxA = a.box_number.toString().trim();
    const boxB = b.box_number.toString().trim();

    // Sort alphanumerically in ascending order
    return boxA.localeCompare(boxB, undefined, {
      numeric: true,
      sensitivity: "base",
    });
  };

  return (
    <div>
      <Modal
        visible={props.visible}
        width={850}
        onCancel={props.onClose}
        footer={false}
      >
        {data?.length ? (
          <ReactToPrint
            trigger={() => <Button type="primary">Print</Button>}
            content={() => componentRef.current}
          />
        ) : null}

        <hr />
        <div ref={componentRef}>
          {isLoading ? (
            <div className="print-customs-box">
              <img src={documentloader} />
            </div>
          ) : (
            <>
              {data && data?.length ? (
                <>
                  {data
                    ?.sort(sortBoxNumber) // Updated sorting with custom function
                    .map((item, boxIndex) => {
                      return (
                        <>
                          {/* First Page - Fixed layout with seal, signature, and terms */}
                          <div
                            style={{
                              pageBreakBefore: boxIndex > 0 ? "always" : "auto",
                            }}
                          >
                            <div
                              className="print-invoice-page"
                              style={{
                                height: "max-content",
                                padding: "20px",
                                fontFamily: "Arial, sans-serif",
                              }}
                            >
                              {/* Header */}
                              <div
                                style={{
                                  textAlign: "center",
                                  marginBottom: "20px",
                                }}
                              >
                                <h2
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    margin: "0",
                                  }}
                                >
                                  UPB / GIFT CARGO DECLARATION FORM
                                </h2>
                                <div
                                  style={{
                                    fontSize: "14px",
                                    marginTop: "10px",
                                  }}
                                >
                                  TO : DIRECTOR GENERAL OF CUSTOMS
                                </div>
                              </div>

                              {/* Sender and Receiver Information */}
                              <div
                                style={{
                                  display: "flex",
                                  gap: "20px",
                                  marginBottom: "10px",
                                }}
                              >
                                {/* Sender Information */}
                                <div
                                  style={{
                                    flex: 1,
                                    border: "2px solid black",
                                    padding: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    SENDER / SHIPPER INFORMATION
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "1.8",
                                    }}
                                  >
                                    <div>
                                      NAME: {item?.collection?.sender_name}
                                    </div>
                                    <div>
                                      ADDRESS:{" "}
                                      {item?.collection?.sender_address}
                                    </div>
                                    <div>ID NO: {item?.iqama_number}</div>
                                    <div>
                                      CONTACT NO:{" "}
                                      {item?.collection?.sender_phone}
                                    </div>
                                    <div>
                                      EMAIL:{" "}
                                      {item?.collection?.sender_email ?? "-"}
                                    </div>
                                  </div>
                                </div>

                                {/* Receiver Information */}
                                <div
                                  style={{
                                    flex: 1,
                                    border: "2px solid black",
                                    padding: "10px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      marginBottom: "10px",
                                      textAlign: "center",
                                    }}
                                  >
                                    RECEIVER / CONSIGNEE INFORMATION
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "1.8",
                                    }}
                                  >
                                    <div>
                                      NAME: {item?.collection?.reciver_name}
                                    </div>
                                    <div>
                                      ADDRESS:{" "}
                                      {item?.collection?.reciver_address}
                                    </div>
                                    <div>ID NO: {item?.adhar_no}</div>
                                    <div>
                                      CONTACT NO:{" "}
                                      {item?.collection?.reciver_phone}
                                    </div>
                                    <div>
                                      EMAIL:{" "}
                                      {item?.collection?.reciver_email ?? "-"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* Items Declaration Table */}
                              <div style={{ marginBottom: "10px" }}>
                                <table
                                  style={{
                                    width: "100%",
                                    border: "2px solid black",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  <thead>
                                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          fontSize: "12px",
                                          fontWeight: "bold",
                                          width: "8%",
                                        }}
                                      >
                                        PKG NO
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          fontSize: "12px",
                                          fontWeight: "bold",
                                          width: "8%",
                                        }}
                                      >
                                        ITEM NO
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          fontSize: "12px",
                                          fontWeight: "bold",
                                          width: "54%",
                                        }}
                                      >
                                        DESCRIPTION OF GOODS
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          fontSize: "12px",
                                          fontWeight: "bold",
                                          width: "15%",
                                        }}
                                      >
                                        QUANTITY
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          padding: "8px",
                                          fontSize: "12px",
                                          fontWeight: "bold",
                                          width: "15%",
                                        }}
                                      >
                                        VALUE
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {item?.boxe_item?.map((item, index) => {
                                      return (
                                        <tr>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "2px",
                                              fontSize: "11px",
                                              paddingRight: "10px",
                                            }}
                                          >
                                            {props?.item?.box_number}
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "2px",
                                              fontSize: "11px",
                                            }}
                                          >
                                            {index + 1}
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "2px",
                                              fontSize: "11px",
                                              alignItems: "center",
                                            }}
                                          >
                                            {item?.item}
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "2px",
                                              fontSize: "11px",
                                            }}
                                          >
                                            {item?.quantity}
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid black",
                                              padding: "2px",
                                              fontSize: "11px",
                                            }}
                                          >
                                            {item?.value}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                              {/* Certification Sections */}
                              <div
                                style={{
                                  display: "flex",
                                  gap: "20px",
                                  marginBottom: "10px",
                                }}
                              >
                                {/* Sender Certification */}
                                <div
                                  style={{
                                    flex: 1,
                                    border: "2px solid black",
                                    padding: "15px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    I CERTIFY THAT, THE ABOVE DETAILS ARE TRUE
                                    AND CORRECT.
                                  </div>

                                  <div
                                    style={{
                                      marginTop: "20px",
                                      fontSize: "11px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        minHeight: "80px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      {item?.signature ? (
                                        <img
                                          src={item?.signature}
                                          style={{
                                            maxHeight: "80px",
                                            maxWidth: "150px",
                                            objectFit: "contain",
                                            display: "block",
                                            border: "1px solid #ccc",
                                            padding: "5px",
                                            backgroundColor: "white",
                                          }}
                                          crossOrigin="anonymous"
                                          alt="Sender Signature"
                                        />
                                      ) : (
                                        <div
                                          style={{
                                            height: "80px",
                                            width: "150px",
                                            border: "1px solid #ccc",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "#f9f9f9",
                                            fontSize: "10px",
                                            color: "#666",
                                          }}
                                        >
                                          No Signature
                                        </div>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        borderTop: "1px solid black",
                                        marginTop: "10px",
                                        paddingTop: "10px",
                                        textAlign: "center",
                                        fontSize: "10px",
                                      }}
                                    >
                                      SIGNATURE OF SENDER / CONSIGNOR
                                      <br />
                                    </div>
                                    <br />
                                    <div
                                      style={{
                                        borderBottom: "1px solid black",
                                        marginBottom: "10px",
                                        paddingBottom: "10px",
                                      }}
                                    >
                                      {item?.collection?.sender_name}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "11px",
                                        marginBottom: "5px",
                                        textAlign: "center",
                                      }}
                                    >
                                      NAME
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: "15px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          borderBottom: "1px solid black",
                                          width: "45%",
                                          paddingBottom: "5px",
                                        }}
                                      >
                                        {item?.collection?.sender_iqama ?? "-"}
                                      </div>
                                      <div
                                        style={{
                                          borderBottom: "1px solid black",
                                          width: "45%",
                                          paddingBottom: "5px",
                                        }}
                                      >
                                        {moment().format("DD-MM-YYYY")}, RIYADH
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        fontSize: "11px",
                                        marginTop: "5px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "45%",
                                          textAlign: "center",
                                        }}
                                      >
                                        ID NO
                                      </div>
                                      <div
                                        style={{
                                          width: "45%",
                                          textAlign: "center",
                                        }}
                                      >
                                        DATE & PLACE
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* Agent Certification */}
                                <div
                                  style={{
                                    flex: 1,
                                    border: "2px solid black",
                                    padding: "15px",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      textAlign: "left",
                                    }}
                                  >
                                    CERTIFICATION BY THE AGENT
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      textAlign: "left",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    SAHARI CARGO
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "11px",
                                      lineHeight: "2",
                                    }}
                                  >
                                    <div>
                                      NO. OF PACKAGES: {item?.boxe_item?.length}
                                    </div>
                                    <div>
                                      WEIGHT: {item?.chargable_weight} KG
                                    </div>
                                    <div>VOLUME: {item?.volume_weight} CBM</div>
                                  </div>

                                  <div
                                    style={{
                                      marginTop: "20px",
                                      textAlign: "center",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        minHeight: "80px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <img
                                        src={Companyseal}
                                        style={{
                                          maxHeight: "80px",
                                          maxWidth: "120px",
                                          objectFit: "contain",
                                          display: "block",
                                          backgroundColor: "white",
                                        }}
                                        crossOrigin="anonymous"
                                        alt="Company Seal"
                                      />
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "10px",
                                        marginTop: "10px",
                                        borderTop: "1px solid black",
                                        paddingTop: "5px",
                                        textAlign: "center",
                                      }}
                                    >
                                      SIGNATURE & AGENT SEAL
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* Warning Notice */}
                              <div
                                style={{
                                  marginTop: "10px",
                                  padding: "5px",
                                  border: "2px solid black",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  WARNING: FALSE OR NON-DECLARATION IS AN
                                  OFFENCE AND MAY INVOLVE HEAVY PENALTIES
                                  INCLUDING FORFEITURE, UNDER THE CUSTOMS
                                  ORDINANCE
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                </>
              ) : (
                <div className="print-manifest-box1">
                  <AiOutlineCloseCircle size={50} color={"red"} />
                  <div style={{ margin: 20 }} />
                  <div>No data found.</div>
                </div>
              )}
            </>
          )}
        </div>
        {data && data?.length ? (
          <Row>
            <Col sm="6"></Col>
            <Col sm="3">
              <ReactToPrint
                trigger={() => (
                  <Button type="primary" block>
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
              />
            </Col>
            <Col sm="3" block>
              <Button onClick={() => props.onClose()}>Cancel</Button>
            </Col>
          </Row>
        ) : null}
      </Modal>
    </div>
  );
}

export default PrintPackingInvoiceModal;
